import { Component, Input, OnInit } from '@angular/core';
import { TooltipPosition } from '@angular/material/tooltip';

export interface EnumerableIconEntry<T extends string> {
  icon: string;
  case: T;
  tooltip?: string;
  tooltipPosition?: TooltipPosition;
}

@Component({
  selector: 'vfs-enumerable-icon',
  templateUrl: './enumerable-icon.component.html',
  styleUrls: ['./enumerable-icon.component.scss']
})
export class EnumerableIconComponent<T extends string> implements OnInit {
  @Input() enumerableIconEntries: EnumerableIconEntry<T>[];
  @Input() selectedValue: T;
  @Input() defaultTooltipPosition?: TooltipPosition = 'below';
  // Icon styles
  @Input() size = '16px';

  constructor() {}

  ngOnInit() {}
}
